import { render } from "./BasicPage.vue?vue&type=template&id=1455acc4&scoped=true"
import script from "./BasicPage.vue?vue&type=script&lang=js"
export * from "./BasicPage.vue?vue&type=script&lang=js"

import "./BasicPage.vue?vue&type=style&index=0&id=1455acc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1455acc4"]])

export default __exports__